import { render, staticRenderFns } from "./InheritanceChain.vue?vue&type=template&id=2a8f0769&scoped=true&"
import script from "./InheritanceChain.vue?vue&type=script&lang=js&"
export * from "./InheritanceChain.vue?vue&type=script&lang=js&"
import style0 from "./InheritanceChain.vue?vue&type=style&index=0&id=2a8f0769&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f0769",
  null
  
)

export default component.exports